import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Grid, Icon, Container } from 'semantic-ui-react';
import logo from 'images/logo/logo_grey.png';

class Footer extends Component {

  render() {
    return (
      <div style={{ paddingTop: 20, paddingBottom: 20, background: 'rgb(240,240,240)', marginTop: 20 }}>
        <Container>
          <Grid>
            <Grid.Column computer={8}>
              <p style={{color: 'rgb(120,120,120)', paddingTop:20, marginBottom: -10, fontSize: 11, marginLeft: 35}}>Powered by</p>
              <img alt="Trialflare logo" src={logo} style={{ width: '100px', paddingBottom: 20 }} />
              <p style={{ color: 'rgb(120,120,120)', fontSize: 11 }}>&copy; {new Date().getFullYear()} Seastorm Limited <br />
              Company number 11867862. Registered in England and Wales.</p>
            </Grid.Column>
            <Grid.Column computer={8} textAlign="right">
              <div style={{ paddingTop: 40 }}>
                <p><Icon name="book" /> <a href='https://trialflare.com/legal' target='_blank' rel='noopener noreferrer'>Privacy Policy</a></p>
                <p><Icon name="book" /> <a href="https://trialflare.com/legal" target='_blank' rel='noopener noreferrer'>Terms of Use</a></p>
              </div>
            </Grid.Column>
          </Grid>
        </Container>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {  };
};
const mapDispatchToProps = dispatch => ({
});

const FooterContainer = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Footer));

export default FooterContainer;
